import * as THREE from 'three';
import Application from '../Application';
import BakedModel from '../Utils/BakedModel';
import UIEventBus from '../UI/EventBus';
export default class Computer {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Default to Night Mode if local hour is early morning (<6) or evening (>18)
        const hour = new Date().getHours();
        this.isNight = hour < 6 || hour > 18;
        this.bakeModel();
        this.setModel();
        // Listen for manual toggling (e.g. from clicking the desk lamp)
        UIEventBus.on('nightModeToggle', (isNight) => {
            this.isNight = isNight;
        });
    }
    bakeModel() {
        this.bakedModel = new BakedModel(this.resources.items.gltfModel.computerSetupModel, this.resources.items.texture.computerSetupTexture, 900);
    }
    setModel() {
        this.scene.add(this.bakedModel.getModel());
    }
    update() {
        // Smoothly fade lighting color
        const targetColor = this.isNight ? new THREE.Color(0x3a3f58) : new THREE.Color(0xffffff);
        this.bakedModel.material.color.lerp(targetColor, 0.05);
    }
}
